import { useEffect, useState } from 'react';
import { countAttachmentMedia, getAttachmentType, MAX_MESSAGE_MEDIA, normalizeAttachments } from '../../helpers/attachments';
import s from './Popup.module.css';

const AttachmentTile = ({ file, onRemove }) => {
    const [url, setUrl] = useState('');
    const type = getAttachmentType(file);

    useEffect(() => {
        if (!['image', 'video'].includes(type)) return;
        const objectUrl = URL.createObjectURL(file);
        setUrl(objectUrl);
        return () => URL.revokeObjectURL(objectUrl);
    }, [file, type]);

    return (
        <div className={s.attachmentTile}>
            {url && type === 'image' && <img src={url} alt={file.name} />}
            {url && type === 'video' && <video src={url} muted playsInline preload="metadata" />}
            <span className={s.attachmentName} title={file.name}>{type === 'video' ? '▶ ' : ''}{file.name}</span>
            {onRemove && <button type="button" className={s.removeAttachment} aria-label={`Убрать ${file.name}`} onClick={onRemove}>×</button>}
        </div>
    );
};

export const AttachmentPreview = ({ files, onRemove }) => {
    const attachments = normalizeAttachments(files);
    if (!attachments.length) return null;
    return (
        <div>
            <div className={s.attachmentCount}>Фото и видео: {countAttachmentMedia(attachments)} / {MAX_MESSAGE_MEDIA}</div>
            <div className={s.attachmentGrid}>
                {attachments.map((file, index) => <AttachmentTile key={`${file.name}_${file.lastModified}_${index}`} file={file} onRemove={onRemove ? () => onRemove(index) : undefined} />)}
            </div>
        </div>
    );
};
